import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nf-error" }
const _hoisted_2 = { class: "nf-error__text" }
const _hoisted_3 = { class: "nf-error__title" }
const _hoisted_4 = { class: "nf-error__label" }
const _hoisted_5 = {
  class: "joy-btn joy-btn_main",
  href: "/project-proposal-summaries"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("img", {
      class: "nf-error__img",
      src: "https://dam.malt.com/rebranding2020/illustrations/Choice?w=400",
      alt: "Error 404",
      width: "200",
      height: "233"
    }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$msg('customer.brief.error.404.title')), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$msg('customer.brief.error.404.label')), 1),
      _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.$msg('customer.brief.error.404.cta')), 1)
    ])
  ]))
}